import { Facebook, Instagram, Linkedin, MessageCircle, Share2, Youtube } from 'lucide-react';

export const DEFAULT_SOCIAL_LINKS = [
  {
    id: 'instagram',
    platform: 'instagram',
    label: '@bringy.latam',
    url: 'https://www.instagram.com/bringy.latam/',
    enabled: true,
  },
  {
    id: 'linkedin',
    platform: 'linkedin',
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/bringy-latam',
    enabled: true,
  },
];

export const SOCIAL_PLATFORM_OPTIONS = [
  { value: 'instagram', label: 'Instagram' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'x', label: 'X (Twitter)' },
  { value: 'threads', label: 'Threads' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'telegram', label: 'Telegram' },
  { value: 'pinterest', label: 'Pinterest' },
  { value: 'snapchat', label: 'Snapchat' },
  { value: 'other', label: 'Other / custom' },
];

const PLATFORM_ICONS = {
  instagram: Instagram,
  linkedin: Linkedin,
  facebook: Facebook,
  youtube: Youtube,
  whatsapp: MessageCircle,
  telegram: MessageCircle,
};

export function getSocialIcon(platform) {
  return PLATFORM_ICONS[platform] ?? Share2;
}

export function getPlatformLabel(link) {
  if (link.platform === 'other' && link.customPlatform?.trim()) {
    return link.customPlatform.trim();
  }
  return SOCIAL_PLATFORM_OPTIONS.find((opt) => opt.value === link.platform)?.label ?? link.platform;
}

export function normalizeSocialLinks(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return DEFAULT_SOCIAL_LINKS;
  return raw.filter((link) => link?.enabled !== false && link?.url && link?.label);
}

export function createEmptySocialLink() {
  return {
    id: `link-${Date.now()}`,
    platform: 'other',
    customPlatform: '',
    label: '',
    url: '',
    enabled: true,
  };
}
